import { useContext } from 'react';
import { useStoreId, ExperienceContext } from '@thd-nucleus/experience-context';
import proptypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useHelmet } from '@thd-nucleus/thd-helmet';
import { getImagePaths } from '../../helpers/product-helpers';
import { HD_URL } from '../../constants';
import { generateTags } from '../../utils';
import { productModel } from '../../models';

const { string } = proptypes;

const pepMetadataHandler = ({ data, props }) => {
  if (!data?.product) return null;

  const { identifiers, media } = data.product;

  const title = identifiers?.productLabel || 'The Home Depot';

  const primaryImage = media?.image?.url;
  const { channel } = props;
  const imageSize = channel === 'mobile' ? 300 : 600;
  const preloadImages = getImagePaths({
    primaryImage,
    mediaImages: media?.images,
    size: imageSize,
  });

  return generateTags({
    title,
    robots: true,
    canonical: HD_URL,
    preloadImages
  });
};

const ProductEntryMetadata = ({ itemId }) => {
  const { channel } = useContext(ExperienceContext);
  const storeId = useStoreId();
  const productOptions = {
    variables: {
      itemId,
      storeId
    }
  };
  const { data } = useDataModel('product', productOptions);

  useHelmet('pepMetadata', { data, props: { channel } }, pepMetadataHandler, [itemId, storeId]);
  return null;
};

ProductEntryMetadata.displayName = 'ProductEntryMetadata';

ProductEntryMetadata.dataModel = productModel;

ProductEntryMetadata.propTypes = {
  itemId: string.isRequired
};

export { ProductEntryMetadata };
